import BpDemoContainer from './BpDemoContainer';

export default BpDemoContainer;
